import React, { useEffect } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { DropzoneArea } from 'material-ui-dropzone';
import { StyledButton } from '../../../Components/Generics.styled';

const UploadLogoContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const UploadAdInput = styled.div`
    min-height: 200px;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;

    .MuiDropzonePreviewList-image {
        max-width: 400px;
        object-fit: cover;
        height: 250px;
        padding-bottom: 100px;
    }

    .MuiDropzonePreviewList-imageContainer {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 200px;
        margin-top: 50px;
        max-width: none;
    }

    .MuiDropzoneArea-root {
        width: 100%;
        height: 100%;
        background-color: #fafbf7;
    }

    .MuiDropzoneArea-active {
        background-color: #2e69fe;
    }
`;

const UploadLogo = (props) => {
    const { handleNavButtonBack, handleNavButtonNext, setLeadGenerationData, leadGenerationData } =
        props;
    const handleFileUpload = (files) => {
        setLeadGenerationData({
            ...leadGenerationData,
            logoFile: {
                ...leadGenerationData.logoFile,
                file: files[0],
            },
        });
    };

    return (
        <UploadLogoContainer>
            <Title>Upload Your Logo</Title>
            <UploadAdInput>
                <DropzoneArea
                    clearOnUnmount={false}
                    filesLimit={1}
                    maxFileSize={300000000}
                    initialFiles={
                        leadGenerationData?.logoFile?.file ? [leadGenerationData.logoFile.file] : []
                    }
                    acceptedFiles={['image/*']}
                    dropzoneText="Drag and drop your file here or click to upload."
                    onChange={(files) => handleFileUpload(files)}
                />
            </UploadAdInput>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={
                        leadGenerationData?.logoFile?.file === undefined ||
                        leadGenerationData?.logoFile?.file === null
                    }
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </UploadLogoContainer>
    );
};

UploadLogo.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        logoFile: propTypes.shape({
            file: propTypes.shape({}),
        }),
        theme: propTypes.shape({
            logoSrc: propTypes.string,
        }),
    }),
    setLeadGenerationData: propTypes.func,
};

UploadLogo.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: { logoFile: {} },
    setLeadGenerationData: () => {},
};
export default UploadLogo;
